const communicationsActions = {
  COMMUNICATIONS_FILTER_CHANGE_SUCCESS: 'COMMUNICATIONS_FILTER_CHANGE_SUCCESS',
};

export default communicationsActions;
